<markant-stepper-horizontal
  class="booking-stepper"
  [numbered]="true"
  [clickable]="false"
  [skippable]="false"
  [currentStepIndex]="stepIndex"
>
  <markant-stepper-item
    [description]="'booking.steps.start' | transloco"
  ></markant-stepper-item>
  <markant-stepper-item
    [description]="'booking.steps.summary' | transloco"
  ></markant-stepper-item>
  <markant-stepper-item
    [description]="'booking.steps.confirmation' | transloco"
  ></markant-stepper-item>
</markant-stepper-horizontal>
